const prefix = 'subscribe';

export const SET_EMAIL = `${prefix}/SET_EMAIL`;

export const SUBSCRIBE = `${prefix}/SUBSCRIBE`;
export const SUBSCRIBE_SUCCESS = `${prefix}/SUBSCRIBE_SUCCESS`;
export const SUBSCRIBE_FAILED = `${prefix}/SUBSCRIBE_FAILED`;
